import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Checkbox from './components/CheckBox';
import AdminPage from './components/AdminPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


